module.exports = __webpack_public_path__ + "img/selected5-min.1b792138.png";